(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/reducers/make-coupon-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/reducers/make-coupon-reducer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _RTK = RTK,
  createReducer = _RTK.createReducer,
  isAnyOf = _RTK.isAnyOf;
const _svs$components$tipse = svs.components.tipsen.engine,
  createCoupons = _svs$components$tipse.createCoupons,
  createPixCoupon = _svs$components$tipse.createPixCoupon;
const _svs$components$tipse2 = svs.components.tipsen.engine.actions,
  clearCoupon = _svs$components$tipse2.clearCoupon,
  clearCouponBoard = _svs$components$tipse2.clearCouponBoard,
  toggleAlternative = _svs$components$tipse2.toggleAlternative,
  toggleOutcome = _svs$components$tipse2.toggleOutcome,
  toggleReduction = _svs$components$tipse2.toggleReduction,
  setExternalCoupon = _svs$components$tipse2.setExternalCoupon,
  selectBetAmount = _svs$components$tipse2.selectBetAmount,
  setSportkryssFactorIndex = _svs$components$tipse2.setSportkryssFactorIndex,
  setSportkryssNumber = _svs$components$tipse2.setSportkryssNumber,
  selectWeek = _svs$components$tipse2.selectWeek,
  selectPixSize = _svs$components$tipse2.selectPixSize,
  placeWager = _svs$components$tipse2.placeWager,
  resetWithCouponValues = _svs$components$tipse2.resetWithCouponValues,
  selectSystem = _svs$components$tipse2.selectSystem,
  toggleMSign = _svs$components$tipse2.toggleMSign,
  generateSportPixCoupon = _svs$components$tipse2.generateSportPixCoupon,
  setCouponValues = _svs$components$tipse2.setCouponValues,
  setSignDistribution = _svs$components$tipse2.setSignDistribution,
  setReduceModeCount = _svs$components$tipse2.setReduceModeCount,
  addCouponValues = _svs$components$tipse2.addCouponValues;
const _svs$components$tipse3 = svs.components.tipsen.engine.constants.couponTypes,
  COUPON_EXTERNAL_SYSTEM = _svs$components$tipse3.COUPON_EXTERNAL_SYSTEM,
  COUPON_XPERT = _svs$components$tipse3.COUPON_XPERT;
const _svs$components$tipse4 = svs.components.tipsen.engine.constants.systems,
  SYSTEM_USYS = _svs$components$tipse4.SYSTEM_USYS,
  SYSTEM_MSYS = _svs$components$tipse4.SYSTEM_MSYS;
const _svs$components$tipse5 = svs.components.tipsen.engine.constants.boardType,
  BOARD_MULTIPLE = _svs$components$tipse5.BOARD_MULTIPLE,
  BOARD_SINGLE = _svs$components$tipse5.BOARD_SINGLE;
const _svs$components$tipse6 = svs.components.tipsen.engine.constants.quickpickProp,
  QUICKPICK_WEIGHTED = _svs$components$tipse6.QUICKPICK_WEIGHTED,
  QUICKPICK_PARTIAL = _svs$components$tipse6.QUICKPICK_PARTIAL,
  QUICKPICK_MODIFIED = _svs$components$tipse6.QUICKPICK_MODIFIED;
const _svs$components$sport = svs.components.sport.drawsRedux.actions,
  loadOpenedDrawsByEngine = _svs$components$sport.loadOpenedDrawsByEngine,
  loadDrawsLite = _svs$components$sport.loadDrawsLite;
const definitions = svs.components.tipsen.engine.definitions;
const relatedTypes = svs.components.sport.drawsRedux.constants.relatedTypes;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const engineCouponSelectorType = svs.components.tipsen.engine.constants.engineCouponSelectorType;
const _svs$components$sport2 = svs.components.sport.tipsenShared.bitmap,
  resetBitmap = _svs$components$sport2.resetBitmap,
  toggleBitValue = _svs$components$sport2.toggleBitValue,
  toggleBitmapValue = _svs$components$sport2.toggleBitmapValue,
  hasBitmapValues = _svs$components$sport2.hasBitmapValues,
  arrayToBitmap = _svs$components$sport2.arrayToBitmap,
  combine = _svs$components$sport2.combine;
const products = svs.utils.products;
const helperGetSigns = (state, _ref) => {
  var _state$couponId$board, _state$couponId;
  let couponId = _ref.couponId,
    board = _ref.board,
    event = _ref.event;
  return (_state$couponId$board = (_state$couponId = state[couponId]) === null || _state$couponId === void 0 || (_state$couponId = _state$couponId.boards[board]) === null || _state$couponId === void 0 ? void 0 : _state$couponId.signs[event]) !== null && _state$couponId$board !== void 0 ? _state$couponId$board : null;
};
const helperGetMSign = (state, _ref2) => {
  var _state$couponId$board2, _state$couponId2;
  let couponId = _ref2.couponId,
    board = _ref2.board,
    event = _ref2.event;
  return (_state$couponId$board2 = (_state$couponId2 = state[couponId]) === null || _state$couponId2 === void 0 || (_state$couponId2 = _state$couponId2.boards[board]) === null || _state$couponId2 === void 0 ? void 0 : _state$couponId2.mSigns[event]) !== null && _state$couponId$board2 !== void 0 ? _state$couponId$board2 : null;
};
const helperToggleMSign = (state, _ref3) => {
  let couponId = _ref3.couponId,
    board = _ref3.board,
    event = _ref3.event;
  state[couponId].boards[board].mSigns[event] = !helperGetMSign(state, {
    couponId,
    board,
    event
  });
};
const setCouponValuesMatrix = _ref4 => {
  let state = _ref4.state,
    couponId = _ref4.couponId,
    signs = _ref4.signs;
  for (let boardIndex = 0; boardIndex < Math.min(signs.length, state[couponId].boards.length); ++boardIndex) {
    state[couponId].boards[boardIndex].signs = state[couponId].boards[boardIndex].signs.map((element, index) => {
      if (signs[boardIndex].signs[index]) {
        return signs[boardIndex].signs[index];
      }
      return element;
    });

    if (signs[boardIndex].mSigns) {
      for (let x = 0; x < signs[boardIndex].mSigns.length; ++x) {
        const activeSigns = helperGetSigns(state, {
          couponId,
          board: boardIndex,
          event: x
        }).filter(sign => sign);
        let mSign = signs[boardIndex].mSigns[x];

        if (activeSigns.length < 2 && mSign) {
          mSign = false;
        }
        state[couponId].boards[boardIndex].mSigns[x] = mSign;
      }
    }

    state[couponId].boards[boardIndex].userSigns = state[couponId].boards[boardIndex].signs;
    state[couponId].boards[boardIndex].signDistribution = state[couponId].boards[boardIndex].signs.map(r => r.map(s => s ? 1 : 0));

    if (signs[boardIndex].uSigns) {
      state[couponId].boards[boardIndex].uSigns = signs[boardIndex].uSigns;
    }
    state[couponId].isModified = true;
  }
};
const setCouponValuesBinary = _ref5 => {
  let state = _ref5.state,
    couponId = _ref5.couponId,
    signs = _ref5.signs,
    reduction = _ref5.reduction;
  for (let boardIndex = 0; boardIndex < Math.min(signs.length, state[couponId].boards.length); ++boardIndex) {
    const board = state[couponId].boards[boardIndex];
    for (let eventIndex = 0; eventIndex < board.signs.length; ++eventIndex) {
      for (let outcomeGroupIndex = 0; outcomeGroupIndex < board.signs[eventIndex].length; ++outcomeGroupIndex) {
        const newValue = arrayToBitmap(signs[boardIndex].signs[eventIndex][outcomeGroupIndex]);
        board.signs[eventIndex][outcomeGroupIndex] = newValue;
      }
    }
    if (reduction && reduction.length) {
      board.reduction = reduction[boardIndex];
    }
    state[couponId].isModified = true;
  }
};
const resetCouponMatrix = _ref6 => {
  let state = _ref6.state,
    couponId = _ref6.couponId,
    keepUserSigns = _ref6.keepUserSigns;
  for (const board of state[couponId].boards) {
    board.pixSize = null;
    board.pixVariant = null;
    if (!keepUserSigns) {
      for (const row of board.userSigns) {
        for (let i = 0; i < row.length; ++i) {
          row[i] = false;
        }
      }
    }
    for (const row of board.signs) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = false;
      }
    }
    for (const row of board.signDistribution) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = 0;
      }
    }
    for (let i = 0; i < board.mSigns.length; ++i) {
      board.mSigns[i] = false;
    }
    for (let i = 0; i < board.uSigns.length; ++i) {
      board.uSigns[i] = null;
    }
  }
};
const resetCouponBinary = _ref7 => {
  let state = _ref7.state,
    couponId = _ref7.couponId,
    keepUserSigns = _ref7.keepUserSigns,
    engineReductionValue = _ref7.engineReductionValue;
  for (const board of state[couponId].boards) {
    if (engineReductionValue) {
      const newReduction = [];
      board.reduction.forEach(() => newReduction.push(engineReductionValue));
      board.reduction = newReduction;
    }
    board.pixSize = null;
    board.pixVariant = null;
    if (!keepUserSigns) {
      for (const eventRow of board.userSigns) {
        for (const row of eventRow) {
          resetBitmap(row);
        }
      }
    }
    for (const eventRow of board.signs) {
      for (const row of eventRow) {
        resetBitmap(row);
      }
    }
  }
};

const resetCoupon = _ref8 => {
  var _state$couponId3;
  let state = _ref8.state,
    couponId = _ref8.couponId,
    _ref8$keepUserSigns = _ref8.keepUserSigns,
    keepUserSigns = _ref8$keepUserSigns === void 0 ? false : _ref8$keepUserSigns,
    _ref8$resetFullCoupon = _ref8.resetFullCoupon,
    resetFullCoupon = _ref8$resetFullCoupon === void 0 ? false : _ref8$resetFullCoupon,
    sportkryssNumber = _ref8.sportkryssNumber,
    reduceModeCount = _ref8.reduceModeCount,
    betAmount = _ref8.betAmount;
  if (((_state$couponId3 = state[couponId]) === null || _state$couponId3 === void 0 ? void 0 : _state$couponId3.engineType) === engineCouponSelectorType.BINARY) {
    const productId = state[couponId].productId;
    const engineDefinition = getDefinitionByProduct(productId);
    const engineReductionValue = engineDefinition.reduction.reduce((sum, value) => sum + value, 0);
    resetCouponBinary({
      state,
      couponId,
      keepUserSigns,
      resetFullCoupon,
      reduceModeCount,
      betAmount,
      engineReductionValue
    });
  } else {
    resetCouponMatrix({
      state,
      couponId,
      keepUserSigns,
      resetFullCoupon,
      sportkryssNumber,
      reduceModeCount,
      betAmount
    });
  }
  if (resetFullCoupon) {
    state[couponId].betAmount = betAmount !== null && betAmount !== void 0 ? betAmount : 1;
    state[couponId].week = 0;
    state[couponId].sportkryss = 0;
    state[couponId].sportkryssNumber = sportkryssNumber;

    if (!state[couponId].selectedSystem === 3) {
      state[couponId].selectedSystem = 0;
    }
    state[couponId].rSystem = null;
    state[couponId].uSystem = null;
    state[couponId].reduceModeCount = reduceModeCount;
  }
  state[couponId].isModified = false;
  state[couponId].xpertAnalysisAuthorId = null;
};
const resetCouponBoard = _ref9 => {
  let state = _ref9.state,
    couponId = _ref9.couponId,
    boardIndex = _ref9.boardIndex,
    keepUserSigns = _ref9.keepUserSigns;
  const board = state[couponId].boards[boardIndex];
  if (board) {
    board.pixSize = null;
    board.pixVariant = null;
    if (!keepUserSigns) {
      for (const row of board.userSigns) {
        for (let i = 0; i < row.length; ++i) {
          row[i] = false;
        }
      }
    }
    for (const row of board.signs) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = false;
      }
    }
    for (const row of board.signDistribution) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = 0;
      }
    }
    for (let i = 0; i < board.mSigns.length; ++i) {
      board.mSigns[i] = false;
    }
    for (let i = 0; i < board.uSigns.length; ++i) {
      board.uSigns[i] = null;
    }
  }
  const _selectCouponEmpty = () => {
    for (const board of state[couponId].boards) {
      for (const row of board.signs) {
        if (row.includes(true)) {
          return false;
        }
      }
    }
    return true;
  };
  if (_selectCouponEmpty()) {
    state[couponId].xpertAnalysisAuthorId = null;
  }
};
const makeCouponReducer = coupons => createReducer(coupons, builder => {
  builder.addCase(setExternalCoupon, (state, action) => {
    const _action$payload = action.payload,
      productId = _action$payload.productId,
      drawId = _action$payload.drawId,
      boards = _action$payload.boards,
      betAmount = _action$payload.betAmount,
      engineType = _action$payload.engineType,
      totalAmountOfRows = _action$payload.totalAmountOfRows,
      guid = _action$payload.guid;
    const couponId = "".concat(productId, "_").concat(drawId, "_").concat(COUPON_EXTERNAL_SYSTEM);
    state[couponId].boards = [...boards];
    state[couponId].betAmount = betAmount;
    state[couponId].engineType = engineType;
    state[couponId].totalAmountOfRows = totalAmountOfRows;
    state[couponId].guid = guid;
  }).addCase(toggleAlternative, (state, action) => {
    const _action$payload2 = action.payload,
      couponId = _action$payload2.couponId,
      boardIndex = _action$payload2.boardIndex,
      event = _action$payload2.event,
      outcome = _action$payload2.outcome,
      systemType = _action$payload2.systemType;
    const board = state[couponId].boards[boardIndex];
    if (!board) {
      return;
    }
    const isUSystem = systemType === SYSTEM_USYS;
    const isSelected = board.signs[event][outcome] === true;
    const hasMoreThanOneSelection = board.signs[event].filter(sign => sign).length > 1;
    const hasNoUSign = board.uSigns[event] === null;
    const hasNoMSign = board.mSigns[event] === false;
    const type = board.type;
    const currentSigns = board.signs[event];
    const previouslySelectedIndex = currentSigns.findIndex(Boolean);
    const hasOneSelection = board.signs[event].filter(sign => sign).length === 1;
    const hasThreeSelections = board.signs[event].filter(sign => sign).length === 3;
    const toggleSelection = () => {
      const currentSign = helperGetSigns(state, {
        couponId,
        board: boardIndex,
        event
      })[outcome];
      const newSign = !currentSign;
      if (type === BOARD_SINGLE) {
        for (let i = 0; i < board.signs[event].length; ++i) {
          board.signs[event][i] = false;
        }
        for (let i = 0; i < board.userSigns[event].length; ++i) {
          board.userSigns[event][i] = false;
        }
      } else if (type !== BOARD_MULTIPLE) {
        throw new Error("Unknown board type: ".concat(type));
      }
      board.signs[event][outcome] = newSign;
      board.userSigns[event][outcome] = board.signs[event][outcome];
      state[couponId].xpertAnalysisAuthorId = null;
      if (currentSign) {
        board.signDistribution[event][outcome] = 0;
      }
      const totalSigns = board.signs[event].length;
      const totalToggledSigns = board.signs[event].filter(sign => sign).length;
      const ratio = totalToggledSigns / totalSigns;
      for (let i = 0; i < board.signDistribution[event].length; ++i) {
        if (board.signs[event][i]) {
          board.signDistribution[event][i] = ratio;
        }
      }
    };
    if (!isSelected && isUSystem && hasNoMSign) {
      if (hasOneSelection) {
        board.uSigns[event] = previouslySelectedIndex;
      }
      toggleSelection();
    } else if (isUSystem && hasNoMSign) {
      if (!hasNoUSign) {
        if (board.uSigns[event] !== outcome) {
          board.uSigns[event] = outcome;
        } else {
          const prev = (outcome + 2) % board.signs[event].length;
          board.uSigns[event] = board.signs[event][prev] && hasThreeSelections ? prev : null;
          toggleSelection();
        }
      } else if (hasMoreThanOneSelection && isSelected) {
        board.uSigns[event] = outcome;
      } else {
        toggleSelection();
        board.uSigns[event] = null;
      }
    } else {
      toggleSelection();
      board.uSigns[event] = null;
    }
    if ([QUICKPICK_PARTIAL, QUICKPICK_WEIGHTED].indexOf(board.pixVariant) !== -1) {
      board.pixVariant = QUICKPICK_MODIFIED;
    }
    const hasSelectedSign = state[couponId].boards.some(board => board.signs.some(event => event.some(sign => sign)));
    state[couponId].isModified = hasSelectedSign;
    const mSign = helperGetMSign(state, {
      couponId,
      board: boardIndex,
      event
    });
    if (mSign) {
      const activeSigns = helperGetSigns(state, {
        couponId,
        board: boardIndex,
        event
      }).filter(sign => sign);
      if (activeSigns.length < 2) {
        helperToggleMSign(state, {
          couponId,
          board: boardIndex,
          event
        });
      }
    }
  }).addCase(toggleOutcome, (state, action) => {
    const _action$payload3 = action.payload,
      couponId = _action$payload3.couponId,
      boardIndex = _action$payload3.boardIndex,
      eventNumber = _action$payload3.eventNumber,
      outcome = _action$payload3.outcome,
      outcomeGroupIndex = _action$payload3.outcomeGroupIndex;
    const board = state[couponId].boards[boardIndex];
    const eventIndex = eventNumber - 1;
    if (!board) {
      return;
    }
    const type = board.type;
    toggleBitmapValue(board.signs[eventIndex][outcomeGroupIndex], outcome);
    toggleBitmapValue(board.userSigns[eventIndex][outcomeGroupIndex], outcome);
    if (type === BOARD_SINGLE) {
      for (let i = 0; i < board.signs[eventIndex][outcomeGroupIndex].length; ++i) {
        board.signs[eventIndex][outcomeGroupIndex][i] = false;
      }
      for (let i = 0; i < board.userSigns[eventIndex].length; ++i) {
        board.userSigns[eventIndex][i] = false;
      }
    } else if (type !== BOARD_MULTIPLE) {
      throw new Error("Unknown board type: ".concat(type));
    }
    const couponSigns = state[couponId].boards.map(board => board.signs.map(eventSigns => eventSigns.map(signs => hasBitmapValues(signs)))).flat(2);
    state[couponId].isModified = Boolean(couponSigns.find(Boolean));
    state[couponId].xpertAnalysisAuthorId = null;
    if ([QUICKPICK_PARTIAL, QUICKPICK_WEIGHTED].indexOf(board.pixVariant) !== -1) {
      board.pixVariant = QUICKPICK_MODIFIED;
    }
  }).addCase(toggleReduction, (state, action) => {
    const _action$payload4 = action.payload,
      couponId = _action$payload4.couponId,
      eventNumber = _action$payload4.eventNumber,
      reduction = _action$payload4.reduction,
      _action$payload4$boar = _action$payload4.boardIndex,
      boardIndex = _action$payload4$boar === void 0 ? 0 : _action$payload4$boar;
    const eventIndex = eventNumber - 1;
    const reductions = state[couponId].boards[boardIndex].reduction;
    const currentReduction = reductions[eventIndex];
    reductions[eventIndex] = toggleBitValue(currentReduction, reduction);
    const productId = state[couponId].productId;
    const engineDefinition = getDefinitionByProduct(productId);
    const engineReductionValue = engineDefinition.reduction.reduce((sum, value) => sum + value, 0);
    const couponReduction = state[couponId].boards[boardIndex].reduction;
    const isReduction = couponReduction.find(eventReductionValue => eventReductionValue < engineReductionValue);
    state[couponId].selectedSystem = isReduction ? 1 : 0;
  }).addCase(setSignDistribution, (state, action) => {
    const _action$payload5 = action.payload,
      couponId = _action$payload5.couponId,
      board = _action$payload5.board,
      event = _action$payload5.event,
      distributions = _action$payload5.distributions;
    state[couponId].boards[board].signDistribution[event] = distributions;
  }).addCase(selectBetAmount, (state, action) => {
    state[action.payload.couponId].betAmount = action.payload.betAmount;
  }).addCase(setSportkryssFactorIndex, (state, action) => {
    state[action.payload.couponId].sportkryss = action.payload.sportkryssFactorIndex;
  }).addCase(setSportkryssNumber, (state, action) => {
    const _action$payload6 = action.payload,
      couponId = _action$payload6.couponId,
      sportkryssNumber = _action$payload6.sportkryssNumber;
    state[couponId].sportkryssNumber = sportkryssNumber;
  }).addCase(clearCoupon, (state, action) => {
    const couponId = action.payload.couponId;
    resetCoupon({
      state,
      couponId
    });
  }).addCase(clearCouponBoard, (state, action) => {
    const _action$payload7 = action.payload,
      couponId = _action$payload7.couponId,
      boardIndex = _action$payload7.boardIndex;
    resetCouponBoard({
      state,
      couponId,
      boardIndex
    });
  }).addCase(selectWeek, (state, action) => {
    state[action.payload.couponId].week = action.payload.week;
  }).addCase(selectPixSize, (state, action) => {
    const couponId = action.payload.couponId;
    state[couponId].selectedAddonPixIndex = action.payload.addonPixChoice;
    resetCoupon({
      state,
      couponId
    });
  }).addCase(loadDrawsLite.fulfilled, (state, action) => {
    const _action$meta$arg = action.meta.arg,
      relatedProductId = _action$meta$arg.relatedProductId,
      type = _action$meta$arg.type;
    const productName = products.getProductClassName(relatedProductId);
    const engineDefinition = definitions[productName];
    for (const drawId of action.payload.Draws.ids) {
      if (type !== relatedTypes.PIX) {
        break;
      }
      const _draw = action.payload.Draws.entities[drawId];
      const draw = {
        productId: _draw.productId,
        drawNumber: _draw.drawNumber,
        sportType: 1,
        drawEvents: new Array(13).fill(null)
      };
      const drawNumber = action.payload.Draws.entities[drawId].drawNumber;
      const newCoupon = createPixCoupon({
        draw,
        engineDefinition
      });
      const oldCoupon = state["".concat(relatedProductId, "_").concat(drawNumber, "_").concat(COUPON_XPERT)] || {};
      state["".concat(relatedProductId, "_").concat(drawNumber, "_").concat(COUPON_XPERT)] = _objectSpread(_objectSpread({}, newCoupon), oldCoupon);
    }
  }).addCase(selectSystem, (state, action) => {
    var _action$payload$rSyst, _action$payload$uSyst;
    state[action.payload.couponId].selectedSystem = action.payload.system;
    state[action.payload.couponId].rSystem = (_action$payload$rSyst = action.payload.rSystem) !== null && _action$payload$rSyst !== void 0 ? _action$payload$rSyst : state[action.payload.couponId].rSystem;
    state[action.payload.couponId].uSystem = (_action$payload$uSyst = action.payload.uSystem) !== null && _action$payload$uSyst !== void 0 ? _action$payload$uSyst : state[action.payload.couponId].uSystem;
    if (action.payload.system !== action.payload.systemTypes.indexOf(SYSTEM_MSYS)) {
      state[action.payload.couponId].lastSelectedSystemType = action.payload.system;
    }
  }).addCase(toggleMSign, (state, action) => {
    const _action$payload8 = action.payload,
      couponId = _action$payload8.couponId,
      board = _action$payload8.board,
      event = _action$payload8.event,
      uSignIndex = _action$payload8.uSignIndex,
      systemType = _action$payload8.systemType;
    helperToggleMSign(state, {
      couponId,
      board,
      event
    });
    if (!state[couponId].boards[board].mSigns[event] && systemType === SYSTEM_USYS) {
      state[couponId].boards[board].uSigns[event] = uSignIndex;
    } else {
      state[couponId].boards[board].uSigns[event] = null;
    }
    state[couponId].xpertAnalysisAuthorId = null;
  }).addCase(setReduceModeCount, (state, action) => {
    state[action.payload.couponId].reduceModeCount = action.payload.value;
  }).addCase(loadOpenedDrawsByEngine.fulfilled, (state, action) => _objectSpread(_objectSpread({}, createCoupons({
    engineDefinition: action.meta.arg,
    draws: action.payload.Draws.entities
  })), state)).addCase(placeWager.fulfilled, (state, action) => {
    const _action$payload9 = action.payload,
      error = _action$payload9.error,
      sportkryssNumber = _action$payload9.sportkryssNumber,
      relatedCouponId = _action$payload9.relatedCouponId,
      shouldPersistBet = _action$payload9.shouldPersistBet;
    if (!error) {
      var _action$meta;
      const _ref0 = ((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.arg) || {},
        couponId = _ref0.couponId;
      const productId = state[couponId].productId;
      const isExternal = couponId.includes(COUPON_EXTERNAL_SYSTEM);
      const productName = products.getProductClassName(productId);
      const engineDefinition = definitions[productName];
      const _ref1 = (engineDefinition === null || engineDefinition === void 0 ? void 0 : engineDefinition.defaultCouponValues) || {},
        betAmount = _ref1.betAmount,
        reduceModeCount = _ref1.reduceModeCount;
      if (shouldPersistBet && !isExternal) {
        return;
      }
      if (isExternal) {
        state[couponId].boards = [];
      } else {
        if (relatedCouponId) {
          state[relatedCouponId].selectedAddonPixIndex = 0;
          resetCoupon({
            state,
            couponId: relatedCouponId,
            resetFullCoupon: true,
            sportkryssNumber,
            reduceModeCount,
            betAmount
          });
        }
        resetCoupon({
          state,
          couponId,
          resetFullCoupon: true,
          reduceModeCount,
          sportkryssNumber,
          betAmount
        });
      }
    }
  }).addCase(addCouponValues, (state, action) => {
    const _action$payload0 = action.payload,
      couponId = _action$payload0.couponId,
      signs = _action$payload0.signs;
    for (let boardIndex = 0; boardIndex < Math.min(signs.length, state[couponId].boards.length); ++boardIndex) {
      const board = state[couponId].boards[boardIndex];
      for (let eventIndex = 0; eventIndex < board.signs.length; ++eventIndex) {
        for (let outcomeGroupIndex = 0; outcomeGroupIndex < board.signs[eventIndex].length; ++outcomeGroupIndex) {
          const currentValue = board.signs[eventIndex][outcomeGroupIndex];
          const newValue = arrayToBitmap(signs[boardIndex].signs[eventIndex][outcomeGroupIndex]);
          board.signs[eventIndex][outcomeGroupIndex] = combine(currentValue, newValue);
        }
      }
    }
    const hasSelectedSign = state[couponId].boards.some(board => board.signs.some(event => event.some(sign => hasBitmapValues(sign))));
    state[couponId].isModified = hasSelectedSign;
  }).addCase(resetWithCouponValues, (state, action) => {
    var _action$meta2, _engineDefinition$def;
    const _action$payload1 = action.payload,
      couponId = _action$payload1.couponId,
      reduceModeCount = _action$payload1.reduceModeCount,
      sportkryssNumber = _action$payload1.sportkryssNumber;
    const _ref10 = ((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.arg) || {},
      relatedCouponId = _ref10.relatedCouponId,
      productId = _ref10.productId;
    const isExternal = couponId.includes(COUPON_EXTERNAL_SYSTEM);
    const productName = products.getProductClassName(productId);
    const engineDefinition = definitions[productName];
    const betAmount = engineDefinition === null || engineDefinition === void 0 || (_engineDefinition$def = engineDefinition.defaultCouponValues) === null || _engineDefinition$def === void 0 ? void 0 : _engineDefinition$def.betAmount;
    if (isExternal) {
      state[couponId].boards = [];
    } else {
      if (relatedCouponId) {
        state[relatedCouponId].selectedAddonPixIndex = 0;
        resetCoupon({
          state,
          couponId: relatedCouponId,
          resetFullCoupon: true,
          sportkryssNumber,
          reduceModeCount,
          betAmount
        });
      }
      resetCoupon({
        state,
        couponId,
        resetFullCoupon: true,
        sportkryssNumber,
        reduceModeCount,
        betAmount
      });
    }
  }).addMatcher(isAnyOf(generateSportPixCoupon.fulfilled), (state, action) => {
    const _action$payload10 = action.payload,
      couponId = _action$payload10.couponId,
      boardSigns = _action$payload10.boardSigns,
      _action$payload10$ove = _action$payload10.overwriteCoupon,
      overwriteCoupon = _action$payload10$ove === void 0 ? true : _action$payload10$ove,
      keepUserSigns = _action$payload10.keepUserSigns,
      rSystem = _action$payload10.rSystem,
      system = _action$payload10.system,
      xpertAnalysisAuthorId = _action$payload10.xpertAnalysisAuthorId;
    if (overwriteCoupon) {
      resetCoupon({
        state,
        couponId,
        keepUserSigns
      });
    }
    for (const _ref11 of Object.entries(boardSigns)) {
      var _action$meta$arg$data, _action$meta3;
      var _ref12 = _slicedToArray(_ref11, 2);
      const boardIndex = _ref12[0];
      const signs = _ref12[1];
      if (!overwriteCoupon) {
        resetCouponBoard({
          state,
          couponId,
          keepUserSigns,
          boardIndex
        });
      }
      const board = state[couponId].boards[boardIndex];
      board.signs = signs;
      board.pixSize = (_action$meta$arg$data = (_action$meta3 = action.meta) === null || _action$meta3 === void 0 || (_action$meta3 = _action$meta3.arg) === null || _action$meta3 === void 0 || (_action$meta3 = _action$meta3.data) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.system) !== null && _action$meta$arg$data !== void 0 ? _action$meta$arg$data : null;
      for (let eventIndex = 0; eventIndex < board.signs.length; ++eventIndex) {
        const totalSigns = board.signs[eventIndex].length;
        const totalToggledSigns = board.signs[eventIndex].filter(sign => sign).length;
        const ratio = totalToggledSigns / totalSigns;
        for (let k = 0; k < board.signDistribution[eventIndex].length; ++k) {
          if (board.signs[eventIndex][k]) {
            board.signDistribution[eventIndex][k] = ratio;
          }
        }
      }
      const hasUserSigns = Array.isArray(board.userSigns) && board.userSigns.some(userSignRow => Array.isArray ? userSignRow.includes(true) : userSignRow);
      board.pixVariant = hasUserSigns ? QUICKPICK_PARTIAL : QUICKPICK_WEIGHTED;
    }
    state[couponId].xpertAnalysisAuthorId = xpertAnalysisAuthorId;
    state[couponId].isModified = true;
    if (typeof system === 'number') {
      state[couponId].selectedSystem = system;
    }
    if (rSystem) {
      state[couponId].rSystem = rSystem;
    }
  }).addMatcher(isAnyOf(setCouponValues, resetWithCouponValues), (state, action) => {
    var _state$couponId4;
    const _action$payload11 = action.payload,
      week = _action$payload11.week,
      betAmount = _action$payload11.betAmount,
      sportkryss = _action$payload11.sportkryss,
      sportkryssNumber = _action$payload11.sportkryssNumber,
      signs = _action$payload11.signs,
      systemType = _action$payload11.systemType,
      rSystem = _action$payload11.rSystem,
      uSystem = _action$payload11.uSystem,
      couponId = _action$payload11.couponId,
      reduction = _action$payload11.reduction;
    if (week !== undefined) {
      state[couponId].week = week;
    }
    if (betAmount !== undefined) {
      state[couponId].betAmount = betAmount;
    }
    if (sportkryss !== undefined) {
      state[couponId].sportkryss = sportkryss;
    }
    if (sportkryssNumber) {
      state[couponId].sportkryssNumber = sportkryssNumber;
    }
    if (((_state$couponId4 = state[couponId]) === null || _state$couponId4 === void 0 ? void 0 : _state$couponId4.engineType) === engineCouponSelectorType.BINARY) {
      setCouponValuesBinary({
        state,
        couponId,
        signs,
        reduction
      });
    } else {
      setCouponValuesMatrix({
        state,
        couponId,
        signs
      });
    }
    if (typeof systemType !== 'undefined') {
      state[couponId].lastSelectedSystemType = systemType;
      state[couponId].selectedSystem = systemType;
      state[couponId].rSystem = rSystem;
      state[couponId].uSystem = uSystem;
    }
  });
});
setGlobal('svs.components.tipsen.engine.reducers.makeCouponReducer', makeCouponReducer);

 })(window);